{
    "Para1": "Selecione um layout de painel entre as opções abaixo:",
    "DashboardDisplaySettings_SectionHeader": "Definições de apresentação",
    "NAME": "DashboardDisplaySettings"
}